export default "__VITE_ASSET__BGQsYBW8__"